const productDataEl=document.getElementById('PulseProductData');
const products=productDataEl?JSON.parse(productDataEl.textContent):{};
let activeProduct='white',activeImage=0,selectedSize='M';
const promoSettings=window.PulsePromo||{enabled:true,label:'DROP OFFER',announcement:'CUMPERI 1 TRICOU → AL DOILEA −50%',cardLead:'2ND TEE',cardDiscount:'−50%',productHeadline:'Cumperi 2, al doilea e -50%.',productDetails:'Se aplică automat în coș. Poți combina modelele.',cartNudge:'Mai adaugă un tricou și primești 50% reducere la al doilea.',cartActive:'Oferta 2nd tee -50% este activă ✓'};
const promoAnnouncement=document.getElementById('promoAnnouncement');
const promoAnnouncementClose=document.getElementById('promoAnnouncementClose');
if(promoAnnouncement&&promoAnnouncementClose){
  promoAnnouncementClose.addEventListener('click',event=>{
    event.preventDefault();
    event.stopPropagation();
    promoAnnouncement.hidden=true;
    try{if(!window.Shopify?.designMode)window.sessionStorage.setItem('pulsePromoDismissed','1')}catch(error){}
  });
}

document.querySelectorAll('.size-guide-component').forEach(component=>{
  const trigger=component.querySelector('.size-guide-trigger');
  const dialog=component.querySelector('.size-guide');
  const close=component.querySelector('.size-guide__close');
  if(!trigger||!dialog||!close||typeof dialog.showModal!=='function')return;
  trigger.addEventListener('click',()=>dialog.showModal());
  close.addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});
});

const heroMedia=document.getElementById('heroMedia'),shell=document.getElementById('heroMediaShell'),dots=document.getElementById('galleryDots');
function renderHero(){
 const p=products[activeProduct],m=p.images[activeImage];
 document.getElementById('heroTitle').innerHTML=p.title;document.getElementById('heroPrice').textContent=p.price;document.getElementById('heroDrop').textContent=p.drop;document.getElementById('heroDescription').textContent=p.description;
 shell.className='hero-media-shell '+(m.type==='primary'?'is-primary':'is-secondary');
 heroMedia.className='hero-media '+(m.type==='primary'?'is-floating':'is-photo');heroMedia.src=m.src;heroMedia.alt=m.alt;
 document.getElementById('galleryCounter').textContent=String(activeImage+1).padStart(2,'0')+' / '+String(p.images.length).padStart(2,'0');
 dots.innerHTML=p.images.map((_,i)=>`<button class="gallery-dot ${i===activeImage?'active':''}" aria-label="Imaginea ${i+1}" data-index="${i}"></button>`).join('');
 dots.querySelectorAll('button').forEach(b=>b.onclick=()=>{activeImage=Number(b.dataset.index);renderHero()});
}
function setProduct(key){activeProduct=key;activeImage=0;renderHero();document.getElementById('hero').scrollIntoView({behavior:'smooth',block:'start'})}
document.getElementById('prevImage').onclick=()=>{const n=products[activeProduct].images.length;activeImage=(activeImage-1+n)%n;renderHero()};
document.getElementById('nextImage').onclick=()=>{const n=products[activeProduct].images.length;activeImage=(activeImage+1)%n;renderHero()};
document.querySelectorAll('.card').forEach(card=>card.querySelector('.card-button').onclick=()=>setProduct(card.dataset.product));
document.querySelectorAll('.size').forEach(btn=>btn.onclick=()=>{document.querySelectorAll('.size').forEach(x=>x.classList.remove('active'));btn.classList.add('active');selectedSize=btn.textContent.trim()});
const qty=document.getElementById('qty');document.getElementById('minus').onclick=()=>qty.value=Math.max(1,Number(qty.value||1)-1);document.getElementById('plus').onclick=()=>qty.value=Math.max(1,Number(qty.value||1)+1);

let addBusy=false;
document.getElementById('addCart').onclick=()=>{
  if(addBusy)return;
  const amount=Number(qty.value||1);
  const cartBtn=document.getElementById('cartBtn');
  const source=document.getElementById('heroMedia');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  addBusy=true;

  const finishAdd=async()=>{
    try{
      await addCurrentProductToCart(amount);
      cartBtn.classList.remove('cart-hit');void cartBtn.offsetWidth;cartBtn.classList.add('cart-hit');
      const t=document.getElementById('toast');
      t.textContent='Produs adăugat în coș';t.classList.add('show');setTimeout(()=>t.classList.remove('show'),1500);
      setTimeout(openCartDrawer,reduced?80:170);
    }catch(err){
      const t=document.getElementById('toast');
      t.textContent=err.message||'Nu am putut adăuga produsul';t.classList.add('show');setTimeout(()=>t.classList.remove('show'),2200);
    }finally{addBusy=false;}
  };

  if(reduced || typeof gsap==='undefined'){finishAdd();return;}

  const sr=source.getBoundingClientRect(),cr=cartBtn.getBoundingClientRect();
  const clone=document.createElement('div');clone.className='fly-to-cart';
  const isMobile=window.matchMedia('(max-width:620px)').matches;
  const w=isMobile?118:150,h=isMobile?148:188;
  const startX=sr.left+sr.width*.52-w/2,startY=sr.top+sr.height*(isMobile?.42:.34)-h/2;
  Object.assign(clone.style,{left:startX+'px',top:startY+'px',width:w+'px',height:h+'px',backdropFilter:'blur(10px)'});
  const ci=document.createElement('img');ci.src=source.src;ci.alt='';clone.appendChild(ci);document.body.appendChild(clone);
  const targetX=cr.left+cr.width/2-startX-w/2,targetY=cr.top+cr.height/2-startY-h/2;
  gsap.timeline({onComplete:()=>{clone.remove();gsap.fromTo(cartBtn,{scale:.78},{scale:1,duration:.48,ease:'back.out(2.2)'});finishAdd();}})
    .fromTo(clone,{scale:.88,opacity:0},{scale:1,opacity:1,duration:.16,ease:'power2.out'})
    .to(clone,{x:targetX*(isMobile?.42:.48),y:targetY*(isMobile?.18:.22)-(isMobile?82:92),rotation:isMobile?-5:-7,scale:isMobile?.80:.72,duration:isMobile?.52:.42,ease:'power2.out'})
    .to(clone,{x:targetX,y:targetY,rotation:isMobile?8:10,scale:isMobile?.18:.12,opacity:.16,duration:isMobile?.62:.48,ease:'power3.in'})
    .to('#addCart',{scale:.975,duration:.08,yoyo:true,repeat:1},0);
};

const heroGallery=document.getElementById('heroGallery');
let swipeStartX=0,swipeStartY=0;
heroGallery.addEventListener('touchstart',e=>{
  if(!e.touches.length)return;
  swipeStartX=e.touches[0].clientX;
  swipeStartY=e.touches[0].clientY;
},{passive:true});
heroGallery.addEventListener('touchend',e=>{
  if(!e.changedTouches.length)return;
  const dx=e.changedTouches[0].clientX-swipeStartX;
  const dy=e.changedTouches[0].clientY-swipeStartY;
  if(Math.abs(dx)<48 || Math.abs(dx)<Math.abs(dy)*1.15)return;
  const n=products[activeProduct].images.length;
  activeImage=dx<0?(activeImage+1)%n:(activeImage-1+n)%n;
  renderHero();
},{passive:true});


// Elastic collection rail — desktop/fine pointer only.
(()=>{
  if(typeof gsap==='undefined')return;
  const wrap=document.querySelector('.cards');
  const cards=[...document.querySelectorAll('.card')];
  const desktop=window.matchMedia('(min-width:1001px) and (hover:hover) and (pointer:fine)');
  if(!wrap || !cards.length || !desktop.matches)return;

  const activate=(active)=>{
    cards.forEach(card=>{
      const on=card===active;
      card.classList.toggle('is-active',on);
      gsap.to(card,{flexGrow:on?1.22:.94,duration:.72,ease:'power3.out',overwrite:true});
      gsap.to(card.querySelector('.card-hint'),{
        maxHeight:on?42:0,
        opacity:on?1:0,
        marginTop:on?9:0,
        duration:.38,
        ease:'power3.out',
        overwrite:true
      });
      gsap.to(card.querySelector('.card-media img'),{
        scale:on?1.012:1.005,
        duration:.82,
        ease:'power3.out',
        overwrite:true
      });
    });
  };

  const reset=()=>{
    cards.forEach(card=>{
      card.classList.remove('is-active');
      gsap.to(card,{flexGrow:1,duration:.76,ease:'power3.out',overwrite:true});
      gsap.to(card.querySelector('.card-hint'),{maxHeight:0,opacity:0,marginTop:0,duration:.32,overwrite:true});
      gsap.to(card.querySelector('.card-media img'),{scale:1.005,duration:.76,ease:'power3.out',overwrite:true});
    });
  };

  cards.forEach(card=>{
    card.addEventListener('mouseenter',()=>activate(card));
    card.querySelector('.card-button').addEventListener('focus',()=>activate(card));
  });
  wrap.addEventListener('mouseleave',reset);
  wrap.addEventListener('focusout',e=>{if(!wrap.contains(e.relatedTarget))reset()});
})();


// Prevent an intentional horizontal swipe on the collection rail from
// accidentally opening a product.
(()=>{
  const wrap=document.querySelector('.cards');
  if(!wrap)return;
  let sx=0,sy=0,dragged=false;
  wrap.addEventListener('touchstart',e=>{
    if(!e.touches.length)return;
    sx=e.touches[0].clientX;sy=e.touches[0].clientY;dragged=false;
  },{passive:true});
  wrap.addEventListener('touchmove',e=>{
    if(!e.touches.length)return;
    const dx=e.touches[0].clientX-sx,dy=e.touches[0].clientY-sy;
    if(Math.abs(dx)>12 && Math.abs(dx)>Math.abs(dy))dragged=true;
  },{passive:true});
  wrap.querySelectorAll('.card-button').forEach(btn=>{
    btn.addEventListener('click',e=>{
      if(dragged){e.preventDefault();e.stopImmediatePropagation();dragged=false;}
    },true);
  });
})();



// Shopify Ajax Cart — only the data source changes; the uploaded drawer design is untouched.
const cartLayer=document.getElementById('cartLayer');
const cartDrawer=document.getElementById('cartDrawer');
const cartBtn=document.getElementById('cartBtn');
const cartLines=document.getElementById('cartLines');
const cartSubtotal=document.getElementById('cartSubtotal');
const cartDrawerCount=document.getElementById('cartDrawerCount');
const cartError=document.getElementById('cartError');
const rootUrl=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
const currency=window.PulseCurrency||'RON';
let cartReturnFocus=null,currentCart=null;

const money=cents=>{try{return new Intl.NumberFormat(document.documentElement.lang||'ro-RO',{style:'currency',currency,minimumFractionDigits:0,maximumFractionDigits:2}).format((Number(cents)||0)/100)}catch(_){return `${Math.round((Number(cents)||0)/100)} ${currency}`}};
const escapeHtml=value=>String(value??'').replace(/[&<>'"]/g,ch=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch]));
function setCartError(message=''){if(!cartError)return;cartError.hidden=!message;cartError.textContent=message}
async function getCart(){const r=await fetch(`${rootUrl}cart.js`,{headers:{Accept:'application/json'}});if(!r.ok)throw new Error('Nu am putut încărca coșul.');return r.json()}
function variantFor(product,size){
  if(!product?.variants?.length)return null;
  const names=(product.optionNames||[]).map(x=>String(x).toLowerCase());
  let idx=names.findIndex(n=>n.includes('size')||n.includes('mărime')||n.includes('marime'));
  if(idx<0)idx=0;
  return product.variants.find(v=>v.available&&String(v.options?.[idx]||'').toUpperCase()===String(size||'').toUpperCase())||product.variants.find(v=>v.available)||product.variants[0];
}
async function addCurrentProductToCart(amount){
  const product=products[activeProduct];
  if(!product?.configured)throw new Error('Selectează produsul în Theme Editor.');
  const variant=variantFor(product,selectedSize);
  if(!variant?.id)throw new Error('Varianta selectată nu este disponibilă.');
  const r=await fetch(`${rootUrl}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variant.id),quantity:Number(amount)||1}]})});
  const data=await r.json();if(!r.ok)throw new Error(data.description||data.message||'Produsul nu a putut fi adăugat în coș.');
  await refreshCart();return data;
}
async function changeCartQty(key,quantity){
  try{setCartError('');const r=await fetch(`${rootUrl}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});const data=await r.json();if(!r.ok)throw new Error(data.description||data.message||'Nu am putut actualiza coșul.');renderCart(data)}catch(err){setCartError(err.message||'Nu am putut actualiza coșul.')}
}
async function changeCartGroupQty(group,quantity){
  try{
    setCartError('');
    const updates=Object.fromEntries(group.lines.map(item=>[item.key,0]));
    if(quantity>0&&group.lines.length)updates[group.lines[0].key]=quantity;
    const r=await fetch(`${rootUrl}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates})});
    const data=await r.json();
    if(!r.ok)throw new Error(data.description||data.message||'Nu am putut actualiza coșul.');
    renderCart(data);
  }catch(err){setCartError(err.message||'Nu am putut actualiza coșul.')}
}
function groupedCartItems(items){
  const groups=new Map();
  for(const item of items||[]){
    const properties=JSON.stringify(Object.entries(item.properties||{}).sort(([a],[b])=>a.localeCompare(b)));
    const sellingPlan=item.selling_plan_allocation?.selling_plan?.id||'';
    const key=[item.variant_id,item.variant_title||'',properties,sellingPlan].join('|');
    let group=groups.get(key);
    if(!group){group={lines:[],quantity:0,linePrice:0,item};groups.set(key,group)}
    group.lines.push(item);group.quantity+=Number(item.quantity)||0;group.linePrice+=Number(item.final_line_price??item.line_price)||0;
  }
  return [...groups.values()];
}
function renderCart(cart){
  currentCart=cart;const quantity=cart.item_count||0;
  document.getElementById('cartCount').textContent=quantity;cartDrawerCount.textContent=quantity;cartSubtotal.textContent=money(cart.total_price);cartLayer.classList.toggle('has-items',quantity>0);
  const promoMessage=document.getElementById('cartOfferMessage');if(promoMessage){promoMessage.hidden=!promoSettings.enabled||quantity<1;promoMessage.classList.toggle('is-active',Number(cart.total_discount||0)>0||quantity>=2);promoMessage.textContent=quantity>=2?promoSettings.cartActive:promoSettings.cartNudge;}
  const groups=groupedCartItems(cart.items);
  cartLines.innerHTML=groups.map((group,index)=>{const item=group.item,title=item.product_title||item.title||'';return `<article class="cart-line" data-cart-group="${index}"><div class="cart-line__image">${item.image?`<img src="${item.image}" alt="${escapeHtml(title)}" loading="lazy" decoding="async">`:''}</div><div class="cart-line__main"><div class="cart-line__head"><h3 class="cart-line__name">${escapeHtml(title)}</h3><div class="cart-line__price">${money(group.linePrice)}</div></div>${item.variant_title&&item.variant_title!=='Default Title'?`<div class="cart-line__variant">${escapeHtml(item.variant_title)}</div>`:''}<div class="cart-line__actions"><div class="cart-line__qty" aria-label="Cantitate ${escapeHtml(title)}"><button type="button" data-cart-minus="${index}" aria-label="Scade cantitatea">−</button><span>${group.quantity}</span><button type="button" data-cart-plus="${index}" aria-label="Crește cantitatea">+</button></div><button class="cart-line__remove" type="button" data-cart-remove="${index}">Șterge</button></div></div></article>`}).join('');
  cartLines.querySelectorAll('[data-cart-minus]').forEach(btn=>btn.onclick=()=>{const group=groups[Number(btn.dataset.cartMinus)];if(group)changeCartGroupQty(group,Math.max(0,group.quantity-1))});
  cartLines.querySelectorAll('[data-cart-plus]').forEach(btn=>btn.onclick=()=>{const group=groups[Number(btn.dataset.cartPlus)];if(group)changeCartGroupQty(group,group.quantity+1)});
  cartLines.querySelectorAll('[data-cart-remove]').forEach(btn=>btn.onclick=()=>{const group=groups[Number(btn.dataset.cartRemove)];if(group)changeCartGroupQty(group,0)});
}
async function refreshCart(){const cart=await getCart();renderCart(cart);return cart}
async function openCartDrawer(){cartReturnFocus=document.activeElement;try{await refreshCart()}catch(err){setCartError(err.message||'Nu am putut încărca coșul.')}cartLayer.classList.add('is-open');cartLayer.setAttribute('aria-hidden','false');cartBtn.setAttribute('aria-expanded','true');document.body.classList.add('cart-open');requestAnimationFrame(()=>document.getElementById('closeCartDrawer').focus())}
function closeCartDrawer(){cartLayer.classList.remove('is-open');cartLayer.setAttribute('aria-hidden','true');cartBtn.setAttribute('aria-expanded','false');document.body.classList.remove('cart-open');if(cartReturnFocus&&typeof cartReturnFocus.focus==='function')cartReturnFocus.focus()}
cartBtn.addEventListener('click',openCartDrawer);document.getElementById('closeCartDrawer').addEventListener('click',closeCartDrawer);document.getElementById('cartBackdrop').addEventListener('click',closeCartDrawer);document.getElementById('continueShopping').addEventListener('click',closeCartDrawer);document.getElementById('continueShoppingEmpty').addEventListener('click',()=>{closeCartDrawer();setTimeout(()=>document.getElementById('shop').scrollIntoView({behavior:'smooth'}),120)});document.addEventListener('keydown',e=>{if(e.key==='Escape'&&cartLayer.classList.contains('is-open'))closeCartDrawer()});
document.getElementById('cartCheckout').addEventListener('click',()=>{window.location.href=`${rootUrl}checkout`});
refreshCart().catch(()=>{});

// Mobile product-image viewer.
(()=>{
  const viewer=document.getElementById('imageViewer');
  const viewerImg=document.getElementById('imageViewerImage');
  const stage=document.getElementById('imageViewerStage');
  const openBtn=document.getElementById('openImageViewer');
  const closeBtn=document.getElementById('closeImageViewer');
  const zoomIn=document.getElementById('zoomIn');
  const zoomOut=document.getElementById('zoomOut');
  const zoomReset=document.getElementById('zoomReset');
  if(!viewer || !viewerImg || !openBtn)return;

  let scale=1,x=0,y=0;
  let dragging=false,startX=0,startY=0,startPX=0,startPY=0;
  let lastTap=0;

  const clamp=(n,a,b)=>Math.max(a,Math.min(b,n));
  const paint=()=>{
    viewerImg.style.transform=`translate3d(${x}px,${y}px,0) scale(${scale})`;
    zoomReset.textContent=Math.round(scale*100)+'%';
  };
  const reset=()=>{scale=1;x=0;y=0;paint()};
  const setScale=(next)=>{
    scale=clamp(next,1,3.2);
    if(scale===1){x=0;y=0}
    paint();
  };
  const open=()=>{
    viewerImg.src=document.getElementById('heroMedia').src;
    viewerImg.alt=document.getElementById('heroMedia').alt||'Imagine produs';
    reset();
    viewer.classList.add('is-open');
    viewer.setAttribute('aria-hidden','false');
    document.body.classList.add('viewer-open');
    closeBtn.focus();
  };
  const close=()=>{
    viewer.classList.remove('is-open');
    viewer.setAttribute('aria-hidden','true');
    document.body.classList.remove('viewer-open');
    openBtn.focus();
  };

  openBtn.addEventListener('click',open);
  closeBtn.addEventListener('click',close);
  zoomIn.addEventListener('click',()=>setScale(scale+.4));
  zoomOut.addEventListener('click',()=>setScale(scale-.4));
  zoomReset.addEventListener('click',reset);

  viewer.addEventListener('click',e=>{if(e.target===viewer)close()});
  document.addEventListener('keydown',e=>{if(e.key==='Escape' && viewer.classList.contains('is-open'))close()});

  stage.addEventListener('pointerdown',e=>{
    if(scale<=1)return;
    dragging=true;
    startX=e.clientX;startY=e.clientY;startPX=x;startPY=y;
    stage.setPointerCapture?.(e.pointerId);
  });
  stage.addEventListener('pointermove',e=>{
    if(!dragging)return;
    x=startPX+(e.clientX-startX);
    y=startPY+(e.clientY-startY);
    paint();
  });
  stage.addEventListener('pointerup',()=>dragging=false);
  stage.addEventListener('pointercancel',()=>dragging=false);

  stage.addEventListener('click',e=>{
    const now=Date.now();
    if(now-lastTap<300){
      setScale(scale>1?1:2);
      lastTap=0;
    }else{
      lastTap=now;
    }
  });
})();


(()=>{
  const mq=window.matchMedia('(max-width:1000px)');
  const cleanup=()=>{
    if(!mq.matches)return;
    document.querySelectorAll('.card').forEach(card=>{
      card.style.removeProperty('flex-grow');
      card.classList.remove('is-active');
      const hint=card.querySelector('.card-hint');
      if(hint){
        hint.style.removeProperty('max-height');
        hint.style.removeProperty('opacity');
        hint.style.removeProperty('margin-top');
      }
      const img=card.querySelector('.card-media img');
      if(img)img.style.removeProperty('transform');
    });
  };
  mq.addEventListener?.('change',cleanup);
  cleanup();
})();


// Newsletter submission is handled by Shopify's native customer form.

(()=>{
  if(typeof gsap==='undefined' || window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const section=document.querySelector('.campaign');
  if(!section)return;
  const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      gsap.fromTo(section.querySelectorAll('.campaign-shot'),
        {y:28,opacity:0},
        {y:0,opacity:1,duration:.8,stagger:.07,ease:'power3.out',clearProps:'transform,opacity'}
      );
      observer.disconnect();
    });
  },{threshold:.12});
  observer.observe(section);
})();

(()=>{
  const menuToggle=document.getElementById('mobileMenuToggle');
  const mobileNav=document.getElementById('mobileNav');
  if(!menuToggle||!mobileNav)return;
  const closeMenu=()=>{
    mobileNav.hidden=true;
    menuToggle.setAttribute('aria-expanded','false');
    menuToggle.setAttribute('aria-label','Deschide meniul');
  };
  menuToggle.addEventListener('click',()=>{
    const opening=mobileNav.hidden;
    mobileNav.hidden=!opening;
    menuToggle.setAttribute('aria-expanded',String(opening));
    menuToggle.setAttribute('aria-label',opening?'Închide meniul':'Deschide meniul');
  });
  mobileNav.querySelectorAll('a').forEach(link=>link.addEventListener('click',closeMenu));
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!mobileNav.hidden){closeMenu();menuToggle.focus()}});
  window.addEventListener('resize',()=>{if(window.innerWidth>1000&&!mobileNav.hidden)closeMenu()});
  document.addEventListener('click',event=>{
    if(!mobileNav.hidden&&!event.target.closest('.pulse-header'))closeMenu();
  });
})();

const productsHeading=document.querySelector('#shop .products-head h2');
if(productsHeading)productsHeading.textContent='DROP 01';

const heroOffer=document.getElementById('heroOffer');
if(promoAnnouncement){
  let promoDismissed=false;
  try{promoDismissed=Boolean(window.sessionStorage.getItem('pulsePromoDismissed'))&&!window.Shopify?.designMode}catch(error){}
  promoAnnouncement.hidden=!promoSettings.enabled||promoDismissed;
  document.getElementById('promoAnnouncementLabel').textContent=promoSettings.label;
  document.getElementById('promoAnnouncementCopy').textContent=promoSettings.announcement;
}
if(heroOffer){
  heroOffer.hidden=!promoSettings.enabled;
  document.getElementById('promoProductLabel').textContent=promoSettings.label;
  document.getElementById('promoProductHeadline').textContent=promoSettings.productHeadline;
  document.getElementById('promoProductDetails').textContent=promoSettings.productDetails;
}
if(promoSettings.enabled){
  document.querySelectorAll('#shop .card-body').forEach(body=>{
    const badge=document.createElement('div');
    badge.className='card-promo';
    const lead=document.createElement('span');
    lead.textContent=promoSettings.cardLead;
    const discount=document.createElement('strong');
    discount.textContent=promoSettings.cardDiscount;
    badge.append(lead,discount);
    body.prepend(badge);
  });
}

renderHero();
